import { Component, input } from '@angular/core';
import type { OnyxPhone } from '@onyx/angular';
import { OnyxPhonePipe } from '@onyx/angular';

@Component({
  selector: 'app-phone-cell',
  imports: [OnyxPhonePipe],
  templateUrl: './phone-cell.component.html',
  styleUrl: './phone-cell.component.scss',
})
export class PhoneCellComponent {
  public readonly phone = input.required<OnyxPhone | null>();
}
